<template>
  <div class="px-5 py-5">
    <notifications position="top center" ></notifications>

    <div class="flex flex-col center-content mb-7">
      <h2 class="font-bold text-center mb-1">Campaign Cards</h2>
      <h4 class="text-center mb-3">{{form.type.toUpperCase()}} Cards</h4>
    </div>




    <div class="space-y-5">

      <div>
        <label for="donation_type" class="block text-sm font-medium text-gray-700">
          Type <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <select id="donation_type" v-model="form.type" class="w-full block sm:text-sm">
            <option value=""></option>
            <option value="video">Video</option>
            <option value="ad">Ad</option>
          </select>
        </div>
      </div>

      <div>
        <label for="title" class="block text-sm font-medium text-gray-700">
          Title <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <input  type="text" v-model="form.title" id="title" autocomplete="" class="w-full block sm:text-sm">
        </div>
      </div>

      <div>
        <label for="link" class="block text-sm font-medium text-gray-700">
          Link <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <input  type="text" v-model="form.link" id="link" autocomplete="" class="w-full block sm:text-sm" placeholder="https://www.youtube.com/embed/vHemPxwRwOw">
        </div>
      </div>

      <div v-if="form.type == `ad`">
        <label for="button_name" class="block text-sm font-medium text-gray-700">
          Button Name <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <input type="text" v-model="form.button_name" id="button_name" autocomplete="off" class="w-full block sm:text-sm">
        </div>
      </div>

      <div>
        <label for="link" class="block text-sm font-medium text-gray-700">
          Image <sup class="text-red required">*</sup>
        </label>
        <div class="border-2 border-gray-300 border-dashed">
<!--          <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent"></vue-dropzone>-->
          <DropZone
              ref="dropzone"
              url="https://giving.side-out.org/add-campaign-card-image"
              :maxFiles="1"
              :uploadOnDrop="false"
              :multipleUpload="false"
              :headers="{'x-csrf-token': this.token}"
              @sending="sending"
          >
            <template v-slot:message><p>To upload your logo/icon, drop a JPG, GIF or PNG file you would like to use here.</p></template>
          </DropZone>
        </div>
      </div>

      <div>
        <label for="description" class="block text-sm font-medium text-gray-700">
          Description <sup class="text-red required">*</sup>
        </label>
        <div class="mt-1">
          <textarea id="description" v-model="form.description" rows="3" class="w-full block sm:text-sm"></textarea>
        </div>
      </div>


      <button @click="saveCard" type="submit" class="inline text-center text-sm uppercase px-6 py-3 border border-transparent font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">{{saveTextCurrent}}</button>
    </div>

    <div class="my-2">&nbsp;</div>

    <div class="xl:border border-gray-200">
      <div class="hidden xl:flex xl:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
        <div class="xl:w-3/12">Title</div>
        <div class="xl:w-5/12">Description</div>
        <div class="xl:w-1/12">Link</div>
        <div class="xl:w-1/12">Image</div>
        <div class="xl:w-1/12">Views</div>
        <div class="xl:w-1/12">&nbsp;</div>
      </div>
      <div class="flex flex-col space-y-3 xl:space-y-0">
        <campaign-card-list v-for="campaignCard in cards" :key="campaignCard.id" :campaign-card="campaignCard" :form-type="form.type" />
      </div>
    </div>

  </div>

</template>


<script>

import DropZone from 'dropzone-vue';
import 'dropzone-vue/dist/dropzone-vue.common.css';

export default {
  components: {
    DropZone
  },
  data() {
    return {
      form: {
        link: null,
        image: null,
        title: null,
        description: null,
        button_name: null,
        type: 'video',
      },
      editForm: {
        link: null,
        image: null,
        title: null,
        description: null,
        button_name: null,
      },
      cards:{},
      saveText : 'Add New Card',
      updateText : 'Update Card',
      isSaving : false,
      recentCampaignCard : {},
      cardToEdit : {},
    }
  },
  created() {
    this.getCards()

    this.emitter.on('campaign-card-updated', () => {
      this.getCards()
    });
  },
  computed: {
    saveTextCurrent() {
      return this.saveText
    },
    updateTextCurrent() {
      return this.updateText
    },
    token() {
      return $('meta[name="csrf-token"]').attr('content')
    },
    cardTitleToEdit() {
      if (!this.cardToEdit) {
        return ''
      }
      return this.cardToEdit.title
    },
  },
  methods: {
    getCards() {
      axios.get('/campaign-cards-get/'+this.form.type)
          .then(response => {
            this.cards = response.data
          })
    },
    sending (file, xhr, formData) {
      formData.append('_token', this.token);
      formData.append('campaign_card_id', this.recentCampaignCard.id);
    },
    saveCard() {
      if (!this.form.title) {
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      if (!this.form.link) {
        this.$notify({
          text: 'Link is required',
          type: 'error',
        })
        return
      }
      if (this.form.type === `ad` && !this.form.button_name) {
        this.$notify({
          text: 'Button Name is required',
          type: 'error',
        })
        return
      }
      if (!this.form.description) {
        this.$notify({
          text: 'Description is required',
          type: 'error',
        })
        return
      }
      this.isSaving = true;
      this.saveText = 'Adding New Card...'

      axios.post('/create-campaign-card', this.form)
          .then(response => {
            this.$notify({text: 'New card added',type: 'success', })
            this.recentCampaignCard = response.data.recent

            this.$refs.dropzone.processQueue()

           setTimeout(() => {
              this.getCards()
            }, 1000)

            this.resetForm()
          })
    },
    resetForm() {
      this.form.link = null;
      this.form.image = null;
      this.form.title = null;
      this.form.description = null;
      this.form.button_name = null;
      this.saveText = 'Add New Card';
      this.isSaving = false
    },
  },
  watch: {
    'form.type': function (val) {
      this.getCards()
    },
  }
}
</script>
<style scoped>
select.input-sm {
  height: 30px;
  line-height: 10px;
}
</style>
